


import request from '@/utils/request'

export default {
  addUserNode(data) {
    return request({
      url: '/usernode/save',
      method: 'post',
      data
    })
  },

  getNoteByPageQuery(data) {
    return request({
      url: '/usernode/getNoteByPageQuery',
      method: 'post',
      data
    })
  },
  
}



// WEBPACK FOOTER //
// ./src/api/usernote.js